import { ManageSelectedOrgProvider } from '@features/organisations/contexts/ManageSelectedOrg'
import { PermissionsCheckerProvider } from '@lib/permissions'
import { createFileRoute, Outlet } from '@tanstack/react-router'

const OrgManagementRoute = () => (
  <ManageSelectedOrgProvider>
    <PermissionsCheckerProvider>
      <Outlet />
    </PermissionsCheckerProvider>
  </ManageSelectedOrgProvider>
)

export const Route = createFileRoute('/_auth/orgs')({
  component: OrgManagementRoute,
  loader: () => ({
    crumb: 'Organisations',
  }),
})
